"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var FileUploadListItem_1 = __importDefault(require("../FileUploadListItem"));
var layout_1 = require("../../../layout");
var FileUploadItemList = function (_a) {
    var items = _a.items, showFileIcon = _a.showFileIcon, removeItem = _a.removeItem, retryItem = _a.retryItem, disabled = _a.disabled;
    return (react_1.jsx(layout_1.Flex, { gap: 12, direction: "column" }, items.map(function (item) { return (react_1.jsx(FileUploadListItem_1.default, { key: item.file.name, item: item, showFileIcon: showFileIcon, onRemove: function () { return removeItem(item.id); }, onRetry: function () { return retryItem(item); }, disabled: disabled })); })));
};
exports.default = FileUploadItemList;
